import { DesignSchemeSet } from '@data/buildingProjects/DesignSchemeSet';
import FVector from '@data/geometry/FVector';
import { DesignSchemeRenderer } from '@rendering/DesignSchemes/DesignSchemeRenderer';
import { BoxRenderer } from '@rendering/DesignSchemes/SingleVolume/BoxRenderer';
import { BoxDesignState, SchemeKey, type LayerKind } from '@visualizer/types';
import Layer from 'Simulations/Layer';
import { DesignScheme } from '../designScheme';

export class Box extends DesignScheme {
    constructor(
        footprint: FVector[],
        footprintId: string,
        set: DesignSchemeSet,
        config: BoxDesignState,
        linkedLayers?: Map<LayerKind, Layer>
    ) {
        super(footprint, footprintId, set, config, linkedLayers);

        // Initialize visibility and update state:
        if (config.active) this.update();
    }

    // Renderer Factory & Defaults:
    protected override createRenderer(config: BoxDesignState): DesignSchemeRenderer {
        return new BoxRenderer(this, config);
    }

    override getRendererKey() {
        return SchemeKey.BOX;
    }
}
